window.sig = cafm.sig = {

    listSettings: null,
    onSignedHandler: 'cafm.sig.onSigned',
    pad: null,

    initForm: function (vm) {

        if (!vm.WorkOrderID || vm.WorkOrderID == cafm.guid.empty) { // offline / not pending sig handling

            var wo = cafm.hd.workOrder;

            if (!wo) {

                return;
            }
            
            var sd = vm.SignatureDescription;
            sd = sd.replace('{0}', cafm.enums.SignatureActivityLabels[sig.signArgs.activity]);
            sd = sd.replace('{1}', cafm.web.funcs.getSessionDateTimeNowText());
            sd = sd.replace('{3}', wo.Reference);
            sd = sd.replace('{4}', wo.Description);

            vm.WorkOrderID = sig.signArgs.workOrderId;
            vm.Activity = sig.signArgs.activity;
            vm.SignatureDescription = sd;
        }

        $('#sigDescription').showMessage({
            Title: vm.SignatureDescription
        })

        // now bind and prepare the form
        $('#signatureForm').bindViewModel(vm).prepareForm().parent().find('.cTb').setupToolbar();
    },
    initList: function(e) {
        
        if (isMobile) $("#backBtn").show();
        body.addClass("view-pendingsignatures");
        this.listSettings = e;
    },    
    signWorkOrder: function (args) {

        var url;
        if (args.workOrderId && args.signatureId) {

            url = 'Signature/WorkOrderSignature/{0}/{1}'.format(args.workOrderId, args.signatureId);
        }
        else {

            url = 'Signature/WorkOrderSignature';
        }

        if (isFunc(args.onSigned)) {

            cafm.handlers.set(sig.onSignedHandler, args.onSigned);
        }
        else {

            cafm.handlers.remove(sig.onSignedHandler);
        }

        // store this as when offline we'll need to set some things client-side
        sig.signArgs = args;

        cafm.views.openActionWindow({
            url: cafm.url.get(url),
            isForm: false, // false so we can prepare the form after binding
            winTitle: cafm.res.str.TitleSignatureRequired,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                height: 600
            },
            onLoad: function (pnl) {

                var sn = $('#sigName');
                sn.enterPressed(function () {

                    sn.blur();
                    if (isMobile) {
                        pnl.find('[data-key="Sign"]').click();
                    }
                    else {
                        pnl.parents('.actionWindow:first').find('[data-key="Sign"]').click();
                    }
                    return false;
                });
                
                setTimeout(function () { sn.focus() }, 500);
            }
        });
    },
    dataRetrieved: function(d){

        cafm.util.convertAllUTCToSessionDateTimes(d, ['CreatedDate']);
    },
    dataBound: function (e) {

        if (sig.listSettings.canSign) {

            e.sender.element.off('click').on('click', 'a.contextTitle', function (e) {

                var item = $(e.currentTarget).parents('.cLvIt:first');

                sig.signWorkOrder({
                    workOrderId: item.data('parentid'),
                    signatureId: item.data('id'),
                    activity: item.data('activity'),
                    onSigned: sig.refreshSignatures
                });
            });
        }
    },
    toolbar: {

        sign: function () {

            var ss1 = $('#sigStep1');
            var v = ss1.kendoValidator().data("kendoValidator");
            cafm.kendo.ext.validator.modify(v);

            if (v.validate()) {
                
                ss1.hide();
                $('#sigStep2').show();
                
                var cWidth = $('#sigContainer').outerWidth();
                if (cWidth > 550) cWidth = 550;
                var cHeight = parseInt(cWidth / 1.272413793103448);
                $('#canvasWidth').changeVal(cWidth);
                $('#canvasHeight').changeVal(cHeight);
                $('#sigCanvas').attr('width', cWidth);
                $('#sigCanvas').attr('height', cHeight);
                $('#sigWrapper').width(cWidth - 2);
                $('#sigWrapper').height(cHeight);

                sig.pad = $('#sigContainer').signaturePad({
                    drawOnly: true,
                    validateFields: false,
                    penColour: '#000',
                    penWidth: 1,
                    lineColour: "#555",
                    bgColour: 'transparent',
                    lineWidth: 0
                });

                var st = $('.sigToolbar');
                st.find('[data-key="Sign"]').hide();
                st.find('[data-key="Close"]').hide();
                st.find('[data-key="Submit"]').show();
                st.find('[data-key="Clear"]').show();
                st.find('[data-key="Back"]').show();
            }
        },
        submit: function () {

            var ss = sig.pad.getSignatureString();

            if (!ss || ss == '[]')
            {
                if (!sig.sigValMsg) {

                    sig.sigValMsg = forms.helpers.generateFieldValidationElement({

                        elementId: 'sigValMsg',
                        message: cafm.res.str.MessageSignatureRequired
                    }).appendTo($('#sigContainer'));
                }
                else {

                    sig.sigValMsg.fadeIn();
                }

                return false;
            }
            else {

                if (sig.sigValMsg) {

                    sig.sigValMsg.fadeOut();
                }

                var sigForm = $('#signatureForm');
                var sigViewModel = sigForm.getViewModel();

                sigViewModel.set('Signature', ss);

                cafm.actions.execute({

                    url: cafm.url.api('WorkOrder/Sign'),
                    values: sigViewModel,
                    elementId: 'signatureForm',
                    loaderSelector: '.winButtons .btn[data-key="Submit"]',
                    offlineActionType: cafm.enums.OfflineActionType.AddSignature,
                    statusCodeFuncs: {

                        200: function (r, s, m) {

                            $('#sigStep2').showMessage({

                                Type: cafm.enums.MessageType.Success,
                                Title: cafm.res.str.MessageSignatureSaved
                            });
                            
                            cafm.handlers.exe(sig.onSignedHandler, r);
                            setTimeout(cafm.views.closeActionWindow, 3000);
                        }
                    },
                    fallback: function () {

                        // get the wo and update props
                        var wo = cafm.hd.workOrder;
                        var hs = cafm.getClientSettings().helpdeskSettings;
                        var woUnchanged;

                        // if resolved and signature completes the work order...
                        if (wo.LifeCycleStatus == cafm.enums.LifeCycleStatus.Resolved && hs.signatureCompletesWorkOrder &&
                            ((wo.Source == cafm.enums.WorkOrderActionSource.Reactive && hs.completeResolvedReactiveWorkOrders) || 
                            (wo.Source == cafm.enums.WorkOrderActionSource.Planned && hs.completeResolvedPlannedWorkOrders))) {

                            // set to completed
                            wo.set('LifeCycleStatus', cafm.enums.LifeCycleStatus.Completed);

                            // will need to re-cache+bind
                            woUnchanged = false;
                        }
                        else {

                            // there will be nothing to re-cache+bind 
                            woUnchanged = true;
                        }

                        // end the offline action
                        hdActions.helpers.endOfflineAction({
                            refreshToolbar: true
                        });
                    }
                });
            }
        },
        clear: function() {

            sig.pad.clearCanvas();
        },
        close: function () {

            cafm.views.closeActionWindow();
        },
        back: function () {

            var ss1 = $('#sigStep1');           
                
            $('#sigStep2').hide();
            ss1.show();

            var st = $('.sigToolbar');
            st.find('[data-key="Sign"]').show();
            st.find('[data-key="Close"]').show();
            st.find('[data-key="Submit"]').hide();
            st.find('[data-key="Clear"]').hide();
            st.find('[data-key="Back"]').hide();
        }
    },
    refreshSignatures: function(){

        cafm.util.refreshList({
            listSelector: '#sigLv',
            key: cafm.res.consts.DataKey_HelpdeskSignatures
        });
    }
}